import styled from '@emotion/styled';
import { Empty as AntEmpty, EmptyProps as AntEmptyProps } from 'antd';
import emptySvg from './assets/empty.svg';

const StyledImg = styled.img`
  width: 60px;
  height: 60px;
`;

interface EmptyProps extends AntEmptyProps {
  imageWidth?: number;
  imageHeight?: number;
}

function Empty(props: EmptyProps) {
  const { imageWidth, imageHeight, ...rest } = props;
  return (
    <AntEmpty
      style={{ color: '#84868c' }}
      image={
        <StyledImg alt="empty" src={emptySvg} style={{ width: imageWidth, height: imageHeight }} />
      }
      {...rest}
    />
  );
}

export default Empty;
